import * as React from 'react'
import { css, SerializedStyles } from '@emotion/react'

type Props = {
  height?: string
  width?: string
  color?: string
  additionalStyles?: SerializedStyles
  onClick?: any
}

export const BinDeleteIcon = ({
  height = '20px',
  width = 'auto',
  color,
  onClick = () => {},
  additionalStyles,
}: Props) => {
  return (
    <svg
      css={[
        css({ height: height, width: width, color: color }),
        additionalStyles,
      ]}
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 14"
      onClick={onClick}
    >
      <path
        d="M0.882353 0.866667C0.648338 0.866667 0.423908 0.957976 0.258435 1.12051C0.0929619 1.28304 0 1.50348 0 1.73333V2.6C0 2.82985 0.0929619 3.05029 0.258435 3.21283C0.423908 3.37536 0.648338 3.46667 0.882353 3.46667H1.32353V11.2667C1.32353 11.7264 1.50945 12.1673 1.8404 12.4923C2.17135 12.8174 2.62021 13 3.08824 13H8.38235C8.85038 13 9.29924 12.8174 9.63019 12.4923C9.96113 12.1673 10.1471 11.7264 10.1471 11.2667V3.46667H10.5882C10.8222 3.46667 11.0467 3.37536 11.2122 3.21283C11.3776 3.05029 11.4706 2.82985 11.4706 2.6V1.73333C11.4706 1.50348 11.3776 1.28304 11.2122 1.12051C11.0467 0.957976 10.8222 0.866667 10.5882 0.866667H7.5C7.5 0.636812 7.40704 0.416372 7.24156 0.253841C7.07609 0.0913093 6.85166 0 6.61765 0L4.85294 0C4.61893 0 4.3945 0.0913093 4.22902 0.253841C4.06355 0.416372 3.97059 0.636812 3.97059 0.866667H0.882353ZM3.52941 4.33333C3.64642 4.33333 3.75863 4.37899 3.84137 4.46025C3.92411 4.54152 3.97059 4.65174 3.97059 4.76667V10.8333C3.97059 10.9483 3.92411 11.0585 3.84137 11.1397C3.75863 11.221 3.64642 11.2667 3.52941 11.2667C3.4124 11.2667 3.30019 11.221 3.21745 11.1397C3.13472 11.0585 3.08824 10.9483 3.08824 10.8333V4.76667C3.08824 4.65174 3.13472 4.54152 3.21745 4.46025C3.30019 4.37899 3.4124 4.33333 3.52941 4.33333ZM5.73529 4.33333C5.8523 4.33333 5.96452 4.37899 6.04725 4.46025C6.12999 4.54152 6.17647 4.65174 6.17647 4.76667V10.8333C6.17647 10.9483 6.12999 11.0585 6.04725 11.1397C5.96452 11.221 5.8523 11.2667 5.73529 11.2667C5.61829 11.2667 5.50607 11.221 5.42334 11.1397C5.3406 11.0585 5.29412 10.9483 5.29412 10.8333V4.76667C5.29412 4.65174 5.3406 4.54152 5.42334 4.46025C5.50607 4.37899 5.61829 4.33333 5.73529 4.33333ZM8.38235 4.76667V10.8333C8.38235 10.9483 8.33587 11.0585 8.25314 11.1397C8.1704 11.221 8.05818 11.2667 7.94118 11.2667C7.82417 11.2667 7.71195 11.221 7.62922 11.1397C7.54648 11.0585 7.5 10.9483 7.5 10.8333V4.76667C7.5 4.65174 7.54648 4.54152 7.62922 4.46025C7.71195 4.37899 7.82417 4.33333 7.94118 4.33333C8.05818 4.33333 8.1704 4.37899 8.25314 4.46025C8.33587 4.54152 8.38235 4.65174 8.38235 4.76667Z"
        style={{ fill: 'currentcolor' }}
      />
    </svg>
  )
}
